// extracted by mini-css-extract-plugin
export default {"landingPageTitle":"LandingPageTitle_landingPageTitle__YCT6j","alt":"LandingPageTitle_alt__cI8jv"};